<script>
    import Navbar from "../widget/Navbar.svelte";
    import Footer from "../widget/Footer.svelte";
    import { onMount } from 'svelte'
    const apiURL = 'https://axcora.com/ngchromisdb/connect.php';
    let data = [];onMount(async function() {const response = await fetch(apiURL);data = await response.json();});

</script>
<Navbar/>
<div class="container">
	<h1>Product Price Cost</h1>

<div class="row p-3">
	{#each data as item}
	<main class="col-md-4 col-12 p-3 border-secondary p-md-5 border-secondary border text-center">
		<p>
        Barcode : {item.code}<br/>
		Item : {item.name}<br/>
		Price : {item.pricebuy}
	</p>
</main>
		{/each}
</div>
</div>
<Footer/>